import React from 'react';

function UpcomingEvents() {
    const eventImg = require("./images/event.png");

    const handleUpcomingEventsButtonClick = () => {
        
    }

    return (
        <div className="upcomingEventsOuterWrapper">
            <div className="upcomingEventsInnerWrapper">
                <img className="upcomingEventsImage" src={eventImg} alt="event"/>
                <div className="upcomingEventsTitle">EVENTS</div>
                <div className="upcomingEventsSubtitle">Join us for in-person game plays and community meetups. Experience the chaos in person.</div>
                <button className="upcomingEventsButton" onClick={handleUpcomingEventsButtonClick}>VIEW EVENTS</button>
            </div>
        </div>
    );
}

export default UpcomingEvents;